import React, { Fragment } from "react";
import _map from "lodash/map";
import { Form } from "semantic-ui-react";
import PropTypes from "prop-types";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { FieldHeader } from "../../components/FieldHeader";

/**
 * * Returns and creates an array format required for semantic drop down
 * @param {array} enumOptions- array of items for the dropdown
 * @param {array} enumDisabled - array of enum option values to disable
 * @returns {*}
 */
function createDefaultValueOptionsForDropDown(enumOptions: any[], enumDisabled: any[], t: any) {
  const disabledOptions = enumDisabled || [];
  let options = [];
  // eslint-disable-next-line no-shadow
  options = _map(enumOptions, ({ label, value }) => ({
    disabled: disabledOptions.indexOf(value) !== -1,
    key: label,
    text: t(label),
    value,
  }));
  return options;
}

function SelectWidget({ schema, id, options, value, label, formContext }: any) {
  const { t } = useSchemaTranslation();

  const { enumDisabled, enumOptions } = options;
  const dropdownOptions = createDefaultValueOptionsForDropDown(
    enumOptions,
    enumDisabled,
    t
  );

  label = schema.title || label;
  const isSelected = (option: any) =>
    Array.isArray(value)
      ? value.includes(option.value)
      : value === option.value;
  const hasSelected = dropdownOptions.find(isSelected);
  return (
    <Form.Field key={id}>
      {label && <FieldHeader> {t(schema.title || label)} </FieldHeader>}
      {!hasSelected ? (formContext.emptyValue || null) :
        dropdownOptions.map((option, index) =>
          isSelected(option) ? (
            <Form.Field id={`${id}_${index}`}>{t(option.text)}</Form.Field>
          ) : (
            <div id={`${id}_${index}`} />
          )
        )}
    </Form.Field>
  );
}

SelectWidget.defaultProps = {
  options: {
    semantic: {
      inverted: "false",
      fluid: true,
      selection: true,
      scrolling: true,
      upward: false,
    },
  },
};

SelectWidget.propTypes = {
  options: PropTypes.object,
};

export default SelectWidget;
